import { get } from 'lodash';

import { IQohInventoryItemVenue } from '@app/shared/types/entities/transfer/transfer.type';

import {
  IReplenishDestination,
  ReplenishDestItemParams,
} from '../replenish.types';
import { ReplenishTransferQOHStrategy } from './replenish-transfer-qoh-strategy';
import { replenishInventoryItem } from './utils/replenish-calc.utils';
import { TRANSFER_FORM_FIELD_PATHS } from '../../transfer/transfer-form-field-paths';
import { expectQtyCalculator } from './calculators/expect-qty.calculator';
import { ReplenishDataSource } from '../replenish-data';

class ReplenishTransferExpectQtyStrategy<
  T extends IReplenishDestination = IReplenishDestination,
> extends ReplenishTransferQOHStrategy<T> {
  /**
   * replenish destination single item method, you can override this to use different calc method here
   *
   * @param params calc params
   * @returns calc result
   */
  public replenishDestinationItem(
    params: ReplenishDestItemParams,
  ): IQohInventoryItemVenue {
    const standWorkSheetData = get(params, [
      'additionalData',
      ReplenishDataSource.StandWorksheet,
      params.item.site_id,
    ]);

    return replenishInventoryItem({
      fieldPath: TRANSFER_FORM_FIELD_PATHS,
      item: params.item,
      threshold: params.threshold,
      percent: params.percent,
      calculator: expectQtyCalculator,
      additionalData: {
        standWorkSheetData: {
          recentEvent: get(standWorkSheetData, 'recentEvent'),
          item: get(standWorkSheetData, ['itemsMap', params.item.entity_id]),
        },
      },
    });
  }
}

export { ReplenishTransferExpectQtyStrategy };
